jQuery  (
        function()
            {
            clearForm = function(selector)
                            {
                            var form = $(selector);

                            form.find(':input').not(':button, :submit, :reset, :checkbox, :radio, [name="_token"], .persist').val('');
                            form.find(':checkbox, :radio').prop('checked', false);
                            }             
            }
        );